import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useQuery } from "react-query";
import { GetCacheKey } from "../../services/common/utils";
import { GTM_View_Items_List, GTM_Select_Item } from "../../../src/analytics/GoogleTagManager";
const ViewAllCards = (dataList) => {
  const location = useLocation();
  const navigate = useNavigate();
  const {
    data: { data } = {},
    isLoading,
    error,
    isFetching,
    isError,
    isLoadingError,
    isSuccess,
  } = useQuery(
    [
      GetCacheKey("special-deals-viewall"),
      dataList?.dataList?.method,
      JSON.parse(dataList?.dataList?.sourceid),
      {},
    ],
    {
      retry: false,
      retryOnMount: false,
      onSuccess: (data) =>{
        try{
          const temp = [];
          data?.data?.response?.filter(item => item?.msisdn === location?.state?.msisdn)?.map( obj => obj?.AvailableOffers?.map((item) => temp.push(item)));
          GTM_View_Items_List(temp, "SpecialDeals_Prepaid");
        }catch{}
      },
      cacheTime: 0,
      staleTime: 0,
    }
  );
  
  const Component = (offerItem) => {

    const handleViewDetails = (e) => {
      e.preventDefault();
      try{
        GTM_Select_Item(offerItem, "SpecialDeals_Prepaid")
      }catch{}
      navigate(`/selected-special-deal-detail/${offerItem?.offercode}`, {
        state: { psmItem: location?.state?.psmItem, msisdn: location?.state?.msisdn, offerid: offerItem?.offerid, specialOfferFlagActive: false},
      });
    };

    return (
      <div style={{ marginBottom: "11px" }}>
        <div className="card_style_2 height_100" onClick={handleViewDetails}>
          <div className="card_img">
            {offerItem?.fifa && (
              <div className="offer_placeholder end-0 top-0">
                <img
                  src={process.env.PUBLIC_URL + "/assets/images/offer-icon.png"}
                  alt=""
                  title=""
                />
              </div>
            )}
            <img
              src={
                offerItem?.image ||
                  process.env.PUBLIC_URL + "/assets/images/s-internet.svg"
              }
              alt=""
              title=""
            />
          </div>
          <div className="card_info">
            <div className="card_info_grp">
              <h4>{offerItem?.title}</h4>
              <p>{offerItem?.description}</p>
            </div>
            <div className="card_link flex_grp_align_center">
              <div
                className="hyperlink"
              >
                {offerItem?.actionbutton}
                <img
                  src={
                    process.env.PUBLIC_URL +
                    "/assets/images/right_arrow_red.svg"
                  }
                  alt=""
                  title=""
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };
  return (
    <>
      {data?.response?.filter(item => item?.msisdn === location?.state?.msisdn)?.map( obj => obj?.AvailableOffers?.map((item) => Component(item)))}
    </>
  );
};

export default ViewAllCards;
